var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showWait)?_c('Loading'):_c('div',[_c('PageTitle',{attrs:{"main":_vm.$t('projecao-agricola'),"sub":"","imagem":"agri.png"}}),_c('HarvestPlanGrid')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }